import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { COOKIE_CONSENT_ACCEPTED, COOKIE_CONSENT_REJECTED } from '../lib/cookieConsent';
import { appliquerChoix, chargerMatomo, trackMatomoPageView } from '../lib/matomo';

// Une page vue par adresse, selon le choix du visiteur (voir lib/matomo.js) :
// sans choix = mesure sans cookie, « Accepter » = avec cookies, « Refuser » = rien.
export default function MatomoTracker({ consent }) {
  const location = useLocation();
  const dernierePage = useRef('');

  useEffect(() => {
    appliquerChoix(consent);
    if (consent === COOKIE_CONSENT_REJECTED) {
      dernierePage.current = '';
    }
  }, [consent]);

  useEffect(() => {
    if (consent === COOKIE_CONSENT_REJECTED) {
      return undefined;
    }

    const path = `${location.pathname}${location.search}${location.hash}`;
    let annule = false;

    chargerMatomo(consent === COOKIE_CONSENT_ACCEPTED)
      .then((charge) => {
        // Accepter pendant la visite ne recompte pas la page déjà mesurée.
        if (!charge || annule || dernierePage.current === path) {
          return;
        }
        dernierePage.current = path;
        trackMatomoPageView(path);
      })
      .catch(() => {});

    return () => {
      annule = true;
    };
  }, [consent, location.pathname, location.search, location.hash]);

  return null;
}
